var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "srd-ogl" } }, [
      _vm._v(
        "\nSome parts of this site (i.e., pages under `/#/dnd/`) make use of Open Game\nLicense content from the Dungeons & Dragons 5th Edition SRD.\nSee "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "http://media.wizards.com/2016/downloads/DND/SRD-OGL_V5.1.pdf"
          }
        },
        [_vm._v("SRD OGL v5.1")]
      ),
      _vm._v(".\n\n"),
      _c("p", [
        _vm._v(
          "The terms of the Open Gaming License Version 1.0a are as follows:"
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("OPEN GAME LICENSE Version 1.0a")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          'The following text is the property of Wizards of the\nCoast, Inc. and is Copyright 2000 Wizards of the\nCoast, Inc ("Wizards"). All Rights Reserved.'
        )
      ]),
      _c("p"),
      _c("p", [
        _vm._v(
          '1. Definitions: (a)"Contributors" means the\ncopyright and/or trademark owners who have\ncontributed Open Game Content; (b)"Derivative\nMaterial" means copyrighted material including\nderivative works and translations (including into\nother computer languages), potation, modification,\ncorrection, addition, extension, upgrade,\nimprovement, compilation, abridgment or other\nform in which an existing work may be recast,\ntransformed or adapted; (c) "Distribute" means to\nreproduce, license, rent, lease, sell, broadcast,\npublicly display, transmit or otherwise distribute;\n(d)"Open Game Content" means the game mechanic\nand includes the methods, procedures, processes\nand routines to the extent such content does not\nembody the Product Identity and is an enhancement\nover the prior art and any additional content clearly\nidentified as Open Game Content by the Contributor,\nand means any work covered by this License,\nincluding translations and derivative works under\ncopyright law, but specifically excludes Product\nIdentity. (e) "Product Identity" means product and\nproduct line names, logos and identifying marks\nincluding trade dress; artifacts; creatures characters;\nstories, storylines, plots, thematic elements, dialogue,\nincidents, language, artwork, symbols, designs,\ndepictions, likenesses, formats, poses, concepts,\nthemes and graphic, photographic and other visual\nor audio representations; names and descriptions of\ncharacters, spells, enchantments, personalities,\nteams, personas, likenesses and special abilities;\nplaces, locations, environments, creatures,\nequipment, magical or supernatural abilities or\neffects, logos, symbols, or graphic designs; and any\nother trademark or registered trademark clearly\nidentified as Product identity by the owner of the\nProduct Identity, and which specifically excludes the\nOpen Game Content; (f) "Trademark" means the\nlogos, names, mark, sign, motto, designs that are\nused by a Contributor to identify itself or its\nproducts or the associated products contributed to\nthe Open Game License by the Contributor (g) "Use",\n"Used" or "Using" means to use, Distribute, copy, edit,\nformat, modify, translate and otherwise create\nDerivative Material of Open Game Content. (h) "You"\n  or "Your" means the licensee in terms of this\nagreement.'
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "2. The License: This License applies to any Open\nGame Content that contains a notice indicating that\nthe Open Game Content may only be Used under and\nin terms of this License. You must affix such a notice\nto any Open Game Content that you Use. No terms\nmay be added to or subtracted from this License\nexcept as described by the License itself. No other\nterms or conditions may be applied to any Open\nGame Content distributed using this License."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "3.Offer and Acceptance: By Using the Open Game\nContent You indicate Your acceptance of the terms of\nthis License."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "4. Grant and Consideration: In consideration for\nagreeing to use this License, the Contributors grant\nYou a perpetual, worldwide, royalty-free, nonexclusive license with the exact terms of this License\nto Use, the Open Game Content."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "5.Representation of Authority to Contribute: If You\nare contributing original material as Open Game\nContent, You represent that Your Contributions are\nYour original creation and/or You have sufficient\nrights to grant the rights conveyed by this License."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "6.Notice of License Copyright: You must update the\nCOPYRIGHT NOTICE portion of this License to\ninclude the exact text of the COPYRIGHT NOTICE of\nany Open Game Content You are copying, modifying\nor distributing, and You must add the title, the\ncopyright date, and the copyright holder's name to\nthe COPYRIGHT NOTICE of any original Open Game\nContent you Distribute."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "7. Use of Product Identity: You agree not to Use any\nProduct Identity, including as an indication as to\ncompatibility, except as expressly licensed in\nanother, independent Agreement with the owner of\neach element of that Product Identity. You agree not\nto indicate compatibility or co-adaptability with any\nTrademark or Registered Trademark in conjunction\nwith a work containing Open Game Content except\nas expressly licensed in another, independent\nAgreement with the owner of such Trademark or\nRegistered Trademark. The use of any Product\nIdentity in Open Game Content does not constitute a\nchallenge to the ownership of that Product Identity.\nThe owner of any Product Identity used in Open\nGame Content shall retain all rights, title and interest\nin and to that Product Identity."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "8. Identification: If you distribute Open Game\nContent You must clearly indicate which portions of\nthe work that you are distributing are Open Game\nContent."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "9. Updating the License: Wizards or its designated\nAgents may publish updated versions of this License.\nYou may use any authorized version of this License\nto copy, modify and distribute any Open Game\nContent originally distributed under any version of\nthis License."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "10. Copy of this License: You MUST include a copy of\nthis License with every copy of the Open Game\nContent You Distribute."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "11. Use of Contributor Credits: You may not market\nor advertise the Open Game Content using the name\nof any Contributor unless You have written\npermission from the Contributor to do so."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "12. Inability to Comply: If it is impossible for You to\ncomply with any of the terms of this License with\nrespect to some or all of the Open Game Content due\nto statute, judicial order, or governmental regulation\nthen You may not Use any Open Game Material so\naffected."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "13. Termination: This License will terminate\nautomatically if You fail to comply with all terms\nherein and fail to cure such breach within 30 days of\nbecoming aware of the breach. All sublicenses shall\nsurvive the termination of this License.\n"
        )
      ]),
      _c("p", [
        _vm._v(
          "14. Reformation: If any provision of this License is\nheld to be unenforceable, such provision shall be\nreformed only to the extent necessary to make it\nenforceable."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "15. COPYRIGHT NOTICE\nOpen Game License v 1.0a Copyright 2000, Wizards\nof the Coast, LLC."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "System Reference Document 5.1 Copyright 2016,\nWizards of the Coast, Inc.; Authors Mike Mearls,\nJeremy Crawford, Chris Perkins, Rodney Thompson,\nPeter Lee, James Wyatt, Robert J. Schwalb, Bruce R.\nCordell, Chris Sims, and Steve Townshend, based on\noriginal material by E. Gary Gygax and Dave Arneson."
        )
      ]),
      _vm._v("\nEND OF LICENSE\n")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6be7e594", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be7e594","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OGL.vue
// module id = null
// module chunks = 